// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"228":"71bb4835","376":"0c932e53","452":"6e7eb527","771":"98012a85","830":"de8bcff3","909":"641e5bdc"}[chunkId] + ".css";
};